import { FormEvent } from 'react'

export function preventDefault /* istanbul ignore next */(e?: FormEvent): void {
  e?.stopPropagation()
  if (e && e.preventDefault) {
    e.preventDefault()
  }
}
